import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export type RehydrateStatus = 'queued' | 'in-progress' | 'already-hot';

export type RehydrateSessionResult = {
  status: RehydrateStatus;
  tier_before: 'hot' | 'cool' | 'cold' | 'archive';
  archive_status: string | null;
  eta_seconds: number;
};

async function rehydrateSession(
  sessionId: string
): Promise<RehydrateSessionResult> {
  const { data } = await Axios.post<RehydrateSessionResult>(
    POST_URL(sessionId).rehydrateSession
  );
  return data;
}

export function useRehydrateSession(sessionId?: string) {
  const queryClient = useQueryClient();
  return useMutation<RehydrateSessionResult, AxiosError<BaseError>>(
    () => {
      if (!sessionId) {
        return Promise.reject(new Error('sessionId is required'));
      }
      return rehydrateSession(sessionId);
    },
    {
      onSuccess: () => {
        if (sessionId) {
          queryClient.invalidateQueries([
            'transcript-editor-session',
            sessionId
          ]);
        }
      }
    }
  );
}
